const actionTypes = {
  SetExportData: 'exporter/SET_EXPORT_DATA',
  SetExportSort: 'exporter/SET_EXPORT_SORT',
  SetExportFilters: 'exporter/SET_EXPORT_FILTERS',
  SetExportReportData: 'exporter/SET_EXPORT_REPORT_DATA',
}

const initialState = {
  outputs: [], // array of data outputs
  from: null, // pdf, what function to utilize via "STRING_TYPE" ie "DISCOVERY", "REPORTING" etc
  sort: null,
  filters: {},
  report: null,
}

export const reducer = (state = initialState, action) => {
  const { type, ...payload } = action.payload || {}

  switch (action.type) {
    case actionTypes.SetExportData:
      return { ...state, ...action.payload.exportData }
    case actionTypes.SetExportSort:
      return { ...state, sort: action.payload }
    case actionTypes.SetExportFilters:
      return { ...state, ...action.payload.filters }
    case actionTypes.SetExportReportData:
      return {
        ...state,
        from: type || null,
        report: action.payload
          ? {
              ...state.report,
              ...payload,
            }
          : null,
      }
    default:
      return state
  }
}

export const actions = {
  setExportData: (exportData) => ({
    type: actionTypes.SetExportData,
    payload: { exportData },
  }),
  setExportSort: (payload) => ({
    payload,
    type: actionTypes.SetExportSort,
  }),
  setExportFiltersData: (filters) => ({
    type: actionTypes.SetExportFilters,
    payload: { filters },
  }),
  setExportReportData: (payload) => ({
    payload,
    type: actionTypes.SetExportReportData,
  }),
}
